export const UD = 'UD'
export const NODE = 'NODE'